import { LocalConfig, NumericalConfig, PaymentConfig } from "@/config";
import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendEvent } from "@/utils/Analytics";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, Toast } from "react-vant";
import style from "./style.less";
import { get } from "react-vant/es/utils";

const minDeposit = NumericalConfig.minDepositAmount / 100;
const maxDeposit = NumericalConfig.maxDepositAmount / 100;

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const DepositPageBlock = (props) => {
  const query = useQuery();
  const backTo = query.get("back_to");
  const { getPersist, setPersist, reloadUserInfo } = useContext(PersistContext);
  const waitingTimer = React.useRef(null);
  const inputRef = React.useRef(null);

  //切换导航
  const history = useEnhancedHistory();

  const [payments, setPayments] = useState(PaymentConfig.payments);

  useEffect(() => {
    let bgSettings = getPersist("bgSettings");
    let merchant_usage = 0;
    if (bgSettings && bgSettings.settings && bgSettings.settings.merchant_usage) {
      merchant_usage = bgSettings.settings.merchant_usage;
    }
    console.log("bgSettings", bgSettings);
    console.log("merchant_usage", merchant_usage);
    let tmpPayments = [];
    for (let i = 0; i < PaymentConfig.payments.length; i++) {
      if (merchant_usage && PaymentConfig.payments[i].merchantId != merchant_usage) {
        continue;
      }
      tmpPayments.push(PaymentConfig.payments[i]);
    }
    setPayments(tmpPayments);

    let defaultPaymentIndex = 0;
    let userPhone = getPersist("user_info") ? getPersist("user_info").rolename : "";
    if (!userPhone || userPhone == "") {
      userPhone = getPersist("last_phone");
    }
    if (userPhone && userPhone != "") {
      for (let i = 0; i < tmpPayments.length; i++) {
        if (tmpPayments[i].checkPrecedence(userPhone)) {
          defaultPaymentIndex = i;
          break;
        }
      }
    }
    setPaymentIndex(defaultPaymentIndex);
  }, [getPersist("bgSettings")]);
  const [backToUrl, setBackToUrl] = React.useState("");
  const [depositOptions, setDepositOptions] = useState(NumericalConfig.depositDefaultOptions);
  const [depositOptionSeleted, setDepositOptionSeleted] = useState(1);
  const [firstRechargeBonus, setFirstRechargeBonus] = useState(false);
  const [recallActOpen, setRecallActOpen] = useState(false);
  const [disableAmountInput, setDisableAmountInput] = useState(false);
  const [paymentIndex, setPaymentIndex] = useState(0);

  //输入框
  let [depositGot, setDepositGot] = useState(NumericalConfig.defaultDepositGot);
  let [depositPrice, setDepositPrice] = useState(NumericalConfig.defaultDepositPrice);

  const [diaLogVisible, setDiaLogVisible] = useState(false);
  const [waitingOrderId, setWaitingOrderId] = useState("");

  useEffect(() => {
    getRechargeLevels();
    if (query.get("deposit_now")) {
      let depositAmount = parseInt(query.get("deposit_now"), 10);
      setDepositPrice(depositAmount);
      setDepositOptionSeleted(null);
      doRecharge(depositAmount);
    }
    if (query.get("wait_order_id")) {
      setWaitingOrderId(query.get("wait_order_id"));
      setDiaLogVisible(true);
    }
    return () => {
      if (waitingTimer.current) {
        clearInterval(waitingTimer.current);
      }
    };
  }, []);
  React.useEffect(() => {
    //有backTo的时候，记住要跳转回去的页面
    if (backTo) {
      setBackToUrl(backTo);
    }
    //没有backTo的时候不管，防止注册登录互切的时候，backTo丢失
    console.log("backTo", backTo);
  }, [backTo]);

  useEffect(() => {
    console.log(diaLogVisible, waitingOrderId);
    if (diaLogVisible && waitingOrderId) {
      if (waitingTimer.current) {
        clearInterval(waitingTimer.current);
      }
      waitingTimer.current = setInterval(() => {
        SendCMD("checkRechargeOrder", {
          token: getPersist("user_info").token,
          order_id: waitingOrderId,
        }).then((res) => {
          if (res.status) {
            if (res.data == "SUCCESS" || res.data == "MANUAL") {
              completedDialog(true);
            } else if (res.data == "FAILD") {
              completedDialog(false);
            }
          }
        });
      }, 2000);
    } else if (waitingTimer.current) {
      clearInterval(waitingTimer.current);
    }
  }, [diaLogVisible, waitingOrderId]);

  const getRechargeLevels = () => {
    console.log("getRechargeLevels", props);
    let params = {};
    if (getPersist("user_info")) {
      params = {
        token: getPersist("user_info").token,
      };
    }
    if (props.useCouponId) {
      params.coupon_id = props.useCouponId;
    }
    SendCMD("getRechargeLevels", params).then((res) => {
      if (!res.status) {
        console.log(res.errdesc);
      } else {
        let option = [];
        let haveMoreOptionIndex = -1;
        res.levels.map((value,index) => {
          option.push(value);
          if (value.more) {
            haveMoreOptionIndex = index;
          }
        });
        if(haveMoreOptionIndex > -1){
          setDepositGot(option[haveMoreOptionIndex].get / 100);
          setDepositPrice(option[haveMoreOptionIndex].price / 100);
          setDepositOptionSeleted(haveMoreOptionIndex);
        }
        setDepositOptions(option);
        if (res.disable_amount_input) {
          setDisableAmountInput(res.disable_amount_input);
        }
        if (res.recall_act_open && res.recall_act_now && res.recall_act_end_time && res.recall_act_now < res.recall_act_end_time) {
          setRecallActOpen(res.recall_act_open);
        }
        setFirstRechargeBonus(res.first_recharge_bonus);
      }
    });
  };

  const doRecharge = (amount) => {
    SendEvent("deposit_click", { price: amount * 100, signed_in: !!getPersist("user_info") });
    if (!getPersist("user_info")) {
      setPersist(
        "login_back_url",
        `${location.pathname + location.search + (location.search ? "&" : "?")}show_pay_popup=${
          props.fromPopup ? "1" : "0"
        }`
      );
      history.push(
        ChannelRemind(
          `/login?${getPersist("last_phone") ? "" : "reg=1&"}back_to=${encodeURIComponent(
            location.pathname +
              location.search +
              (location.search ? "&" : "?") +
              (props.fromPopup ? "show_pay_popup=1" : "")
          )}`
        )
      );
      return;
    }
    let requestDeposit = depositPrice;
    if (amount) {
      requestDeposit = amount;
    }
    if (!requestDeposit || requestDeposit < minDeposit) {
      return;
    }

    if (requestDeposit > 0) {
      setDiaLogVisible(true);
      // SendCMD("simulateRecharge", {
      SendCMD("recharge", {
        token: getPersist("user_info").token,
        price: requestDeposit * 100,
        merchant_id: payments[paymentIndex].merchantId,
        coupon_id: props.useCouponId ? props.useCouponId : 0,
        type: payments[paymentIndex].type,
      }).then((res) => {
        if (!res.status) {
          console.log(res);
          if (res.errdcode == "recharge_13") {
            SendEvent("deposit_request_failed", { price: requestDeposit * 100, reason: res.errdesc });
            setDiaLogVisible(false);
            Toast.success({ message: "Too many requests!\nPlease try again later.", duration: 4000 });
            return;
          }
          SendEvent("deposit_request_failed", { price: requestDeposit * 100, reason: res.errdesc });
          setDiaLogVisible(false);
          Toast.success({ message: "Error", duration: 2000 });
        } else {
          console.log(res.data.order_id);
          SendEvent("deposit_request_success", { price: requestDeposit * 100 });
          if (res.data.checkout_url) {
            window.location.href = res.data.checkout_url;
          } else {
            setWaitingOrderId(res.data.order_id);
          }
        }
      });
    }
  };

  const completedDialog = (success) => {
    setDiaLogVisible(false);
    setWaitingOrderId("");
    reloadUserInfo();
    if (props.completedDialog && typeof props.completedDialog == "function") {
      return props.completedDialog(success);
    }
    if (typeof success != "undefined") {
      if (success) {
        SendEvent("deposit_confirm_success");
        Toast.success({
          message: `Success`,
          duration: 2000,
          onClose: () => {
            history.replace(ChannelRemind("/home"));
            Toast.clear();
          },
        });
      } else {
        SendEvent("deposit_confirm_failed");
        Toast.fail({
          message: `Error`,
          duration: 2000,
        });
      }
    } else {
      SendEvent("deposit_confirm_clicked");
      history.replace(ChannelRemind("/home"));
      Toast.clear();
    }
  };

  const onDepositInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      if (typeof value == "string") {
        value = parseInt(value, 10);
      }
      if (value > maxDeposit) {
        value = maxDeposit;
      }
      if (value < 1) {
        value = 1;
      }
      inputRef.current.value = value;
      setDepositGot(value);
      setDepositPrice(getDepositPriceByGot(value));
    }
  };

  const onOptionSelected = (index) => {
    setDepositGot(depositOptions[index].get / 100);
    setDepositPrice(depositOptions[index].price / 100);
    setDepositOptionSeleted(index);
  };

  const getDepositPriceByGot = (got) => {
    let price = got;
    depositOptions.map((option) => {
      if (option.get == got * 100) {
        price = option.price / 100;
      }
    });
    return price;
  };

  return (
    <div class={style.deposit_content}>
      <div class={style.deposit_title}>Select amount below</div>
      <div class={style.depevebox}>
        {depositOptions.map((option, i) => {
          return (
            <div
              key={i}
              class={style.depeveboxson + (depositOptionSeleted === i ? ` ${style.depeveboxson_active}` : "")}
              onClick={() => {
                SendEvent("deposit_option_click", {
                  index: i,
                  price: option.price,
                  signed_in: !!getPersist("user_info"),
                });
                onOptionSelected(i);
              }}
            >
              {option.hot ? <div class={style.hotdiv}>Hot</div> : null}
              {option.more ? <div class={style.morediv}>+{option.more}%</div> : null}
              {option.price == NumericalConfig.depositActivityAmount && recallActOpen ? <div class={style.morediv}>+{NumericalConfig.depositActivityMore / 100}</div> : null}
              {option.price == NumericalConfig.firstRechargeAmount && firstRechargeBonus ? (
                <div class={style.hotdiv}>1st-time+20%</div>
              ) : null}
              <div class={style.depone} style={depositOptionSeleted === i ? "color: #004b20;" : null}>
                {LocalConfig.currencyCode}
              </div>
              <div class={style.depone_get} style={depositOptionSeleted === i ? "color:  #004b20;" : null}>
                {(option.get / 100).toFixed(2)}
              </div>
              <div class={style.deptwo} style={depositOptionSeleted === i ? "color:  #004b20;" : null}>
                Price {(option.price / 100).toFixed(2)}
              </div>
            </div>
          );
        })}
      </div>
      {disableAmountInput ? null : (
        <>
          <div class={style.deposit_inbox}>
            <input
              type="text"
              ref={inputRef}
              class={style.deposit_changemoney}
              value={depositGot ? depositGot : ""}
              onClick={() => {
                SendEvent("click_deposit_input");
              }}
              onChange={(value) => {
                onDepositInputChange(value);
              }}
              onFocus={() => setDepositOptionSeleted(null)}
            />
            <div class={style.deposit_pol}>
              {LocalConfig.currencyCode}
              <span />
            </div>
            <div
              class={style.deposit_fork}
              onClick={() => {
                setDepositGot(null);
                setDepositPrice(null);
                setDepositOptionSeleted(null);
              }}
            >
              ×
            </div>
            <p />
          </div>
          <div class={style.deposit_amount_intro}>
            The minimum amount is {LocalConfig.currencyCode} {(NumericalConfig.minDepositAmount / 100).toFixed(2)}
          </div>
        </>
      )}

      <div class={style.deposit_choose}>
        <div class={style.deposit_top}>
          {payments.map((payment, index) => {
            return (
              <div
                key={payment.type}
                class={index == paymentIndex ? style.fatherbox_active : style.fatherbox}
                onClick={() => setPaymentIndex(index)}
              >
                <div
                  class={index == paymentIndex ? style.son_active : style.son}
                  style="background-color: #082f2c; color: rgb(69, 66, 50);"
                >
                  <div style={{ height: "2rem", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <img style={{ width: "3.3rem", maxHeight: "1.7rem" }} src={payment.img} alt="" />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      marginTop: "0.2rem",
                      marginBottom: "0.3rem",
                      color: "#fff",
                    }}
                  >
                    {payment.text}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div class={style.bottom} style="border-top-left-radius: 0px;">
          <img
            src="../assets/images/home/icon_tanhao.png"
            alt=""
            style={{ marginLeft: "0.4rem", marginTop: "-0.4rem" }}
          />
          <div>
            <div class={`${style.depositeText} ${style.greenColor}`}>
              This channel is currently normal, please feel free to deposit.
            </div>
          </div>
        </div>
      </div>
      <div class={style.btncommontwo}>
        <div class={style.paybtnbox}>
          <button
            class={`${style.paybtn} ${style.paybtn1}${depositGot < minDeposit ? ` ${style.paybtn_disabled}` : ""}`}
            onClick={() => doRecharge()}
          >
            Pay{" "}
            <span style="margin-left: .35rem;">
              {LocalConfig.currencyCode} {depositGot && depositGot >= minDeposit ? depositPrice.toFixed(2) : null}
            </span>
          </button>
        </div>
      </div>
      <div class={style.deposit_phone}>
        <img src={LocationInfo().flag} alt="" />
        <span class={style.deposit_pc}>+{LocationInfo().phoneStartsWith}</span>
        <span>{getPersist("user_info") ? getPersist("user_info").rolename : null}</span>
      </div>
      <p class={style.depositedes}>
        You can only use your registering number to top up your wallet. Please duoble-check the number before you pay.
      </p>
      <div class={style.deposit_describe}>
        <h5>----------- Deposit Tips -----------</h5>
        <p> 1.Select or enter the amount to deposit your wallet. </p>
        <p>
          {" "}
          2.The minimum amount is {LocalConfig.currencyCode} {(NumericalConfig.minDepositAmount / 100).toFixed(2)}.{" "}
        </p>
        <p> 3.Only Mepsa cash are available. </p>
        <p> 4.Please ensure that you choose right network/operator and your mobile wallet has enough money. </p>
        <p> 5.If failed to deposit due to network issue, please try again later or contact our customer service. </p>
      </div>
      <Dialog
        visible={diaLogVisible}
        title={
          <div class={style.deposit_puptop}>
            <p class={style.deposit_load}>We have sent a payment request to your phone.Please check your phone</p>
          </div>
        }
        className={style.depositDialog}
        showCancelButton={false}
        showConfirmButton={false}
      >
        <div class={style.dialog_content}>
          <div class={style.infinite_progress}>
            <div class={style.infinite_progress_img}></div>
          </div>
          <div class={style.pup_tips}>
            <p>Tips:This page will refresh automatically after receiving the payment.</p>
          </div>
          <div class={style.pup_make}>
            <p class={style.pup_p1}>Make Sure you have sufficient balance.</p>
          </div>
          <div class={style.pup_btn}>
            <button class="" onClick={() => completedDialog()}>
              Confirm
            </button>
          </div>
          <div class={style.pup_foot}>
            <p>
              Close the page and restart if deposit failed due to internet issue. If you have any questions please
              contact customer service!
            </p>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default DepositPageBlock;
